<template>
  <div :class="$style.product">
    队列关联产品：
    <span
      v-for="(product, index) in products"
      :key="index"
    >
      {{ product }}
      <span class="ml5 mr5" v-if="index < len - 1">|</span>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    products: Array
  },
  computed: {
    len() {
      return this.products?.length
    }
  }
}
</script>

<style lang="scss" module>
.product {
  padding: 10px;
  border: 1px solid #909399;
  border-radius: 4px;
}
</style>